
import React, { lazy, Suspense, useEffect, useState } from 'react';
import { requestNotificationPermission } from '../utils/notificationService';
import PWAInstallPrompt from './pwaInstallPrompt';
import { Route, Routes, Navigate } from 'react-router-dom';
import HomePage from './homePage';
import requireAuth from './requireAuth';
import AuthService from '../utils/authService'
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import * as adminActions from '../actions/admin';
import LoginPage from './loginPage';
import ForgotPasswordPage from './forgotPasswordPage'
import ChangePasswordPage from './changePasswordPage';
import ProfilePage from './profilePage';
import Header from './header';
import SideMenu from './menu/menu';
import {AbilityContext} from './can'
import {defineAbilitiesFor} from '../utils/ability';


const AdminSubLayout = lazy(() => import('./admin/adminSubLayout')); 

const RegisterSubLayout = lazy(() => import('./register/registerSubLayout')); 

const SitelogSubLayout = lazy(() => import('./sitelog/sitelogSubLayout')); 



const App = (props) => {

    const abilities = defineAbilitiesFor();

    // CHECKPOINT-75: a user forced to change their password must do so before the
    // app loads. Don't fetch the menu in that state, and render the change screen
    // instead of the app shell (below) — no redirect, so there is no loop.
    const mustChange = AuthService.loggedIn() && AuthService.mustChangePassword();

    useEffect(() => {
        // Request notification permission when user is logged in
        if (AuthService.loggedIn()) {
            requestNotificationPermission().then(granted => {
                if (granted) {
                    console.log('✅ Notifications enabled');
                } else {
                    console.log('⚠️ Notifications not enabled');
                }
            });
        }
    }, []);

    if (AuthService.loggedIn() && !mustChange) {

        props.actions.loadMenu().then(f => {

       })
       .catch(e => { console.log(e); AuthService.logout(); return false; });
    }

    return (

      <>


        {AuthService.loggedIn() && mustChange ?

          <ChangePasswordPage />

        : AuthService.loggedIn() ?

          <AbilityContext.Provider value={abilities}>
            
            <Header />

            <div className="sidebar-overlay" onClick={() => { document.body.classList.remove('show-sidebar'); const icon = document.querySelector('.nav-toggler i'); if (icon) icon.className = 'mdi mdi-menu'; }} />

            <SideMenu />

            <Suspense fallback={<h1>Still Loading…</h1>}></Suspense>

            <Routes>
              <Route exact path='/' Component={requireAuth(HomePage, {isLoggedIn:AuthService.loggedIn(), title:'Home'})} />   
              <Route exact name='LoginPage' path='/login' Component={LoginPage} />  
              <Route path='/admin/*' Component={requireAuth(AdminSubLayout, {isLoggedIn:AuthService.loggedIn(), title:'Admin'})} />
              <Route path='/register/*' Component={requireAuth(RegisterSubLayout, {isLoggedIn:AuthService.loggedIn(), title:'Register'})} />
              <Route path='/sitelog/*' Component={requireAuth(SitelogSubLayout, {isLoggedIn:AuthService.loggedIn(), title:'Site Log'})} />
              <Route path='/ProfilePage' Component={requireAuth(ProfilePage, {isLoggedIn:AuthService.loggedIn(), title:'Profile'})} /> 
            
            </Routes>

          
          </AbilityContext.Provider>
          
        : 

          <div className="login">

            <Routes>
              <Route path='/' Component={LoginPage} />
              <Route exact path='/forgotPasswordPage' Component={ForgotPasswordPage} />
              <Route path='*' element={<Navigate to='/' replace />} />
            </Routes>

          </div>
        }

      </>
    
    )
  
      
  }


 
function mapStateToProps(state) { 
  return {loggedIn: state.loggedIn}
}

function mapDispatchToProps(dispatch) {
  return {
      actions: bindActionCreators(adminActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);